import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedCart: null,
    isAssignedCartPerson: true,
};

const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        handaleSelectedCart(state, action) {
            state.selectedCart = action.payload;
        },
        handaleIsAssignedCartPerson(state, action) {
            state.isAssignedCartPerson = action.payload;
        },
    },
});

export const { handaleSelectedCart, handaleIsAssignedCartPerson } = cartSlice.actions;

export default cartSlice.reducer;
